import { sortBy } from 'lodash'
import React from 'react'
import { CertificateDetailsUtils } from '../shared/CertificateDetailsUtils'
import classes from './Parties.module.scss'
import PartiesMultipleValueTemplate from './PartiesMultipleValueTemplate/PartiesMultipleValueTemplate'
import PartiesSingleValueTemplate from './PartiesSingleValueTemplate/PartiesSingleValueTemplate'

interface PartiesProps {
  partiesAttribute: any
  partiesData: any
  isExpanded: boolean
  requestPartyValue: (key: string, value: string) => any
}

const Parties = (props: PartiesProps) => {
  const certAttributes = props?.partiesAttribute?.cert_attributes ?? []

  const sortedPartiesAttributes = React.useMemo(() => {
    const mappedAttributes = certAttributes.map((attribute: any) => {
      return {
        ...attribute,
        isMultiple: attribute?.max_value === 'n',
      }
    })

    return sortBy(mappedAttributes, ['isMultiple', 'attribute_name'])
  }, [props?.partiesAttribute?.cert_attributes])

  const InlineRenderParties = () => {
    return (
      <>
        {sortedPartiesAttributes.map((attribute: any, index: number) => {
          let partyAttributeName = CertificateDetailsUtils.getPartyAttributeName(
            attribute?.attribute_name
          )

          if (attribute?.max_value === '1') {
            const getValue = props?.partiesData?.find(
              (data: any) => data?.attribute_name === partyAttributeName
            )?.value
            return (
              <PartiesSingleValueTemplate
                key={`parties-single-value-${index}-${attribute?.attribute_name}`}
                value={getValue && getValue.length > 0 ? getValue[0] : ''}
                title={attribute?.display_name}
                isExpanded={props.isExpanded}
                rowClassname={`ul-grid__row`}
                titleClassname={`ul-grid__column ${
                  props.isExpanded ? '-x30' : `-x50 ${classes['parties-overflow-wrap']}`
                }`}
                valueClassname={`ul-grid__column ${
                  props.isExpanded ? '-x70' : `-x50 ${classes['parties-overflow-wrap']}`
                }`}
              />
            )
          }

          if (attribute?.max_value === 'n') {
            const getValues = props?.partiesData?.find(
              (data: any) => data?.attribute_name === partyAttributeName
            )?.value
            return (
              <PartiesMultipleValueTemplate
                key={`parties-multiple-value-${index}-${attribute?.attribute_name}`}
                title={attribute?.display_name}
                attribute={attribute}
                values={getValues ?? []}
              />
            )
          }
          return <React.Fragment key={`parties-value-fragment-empty-${index}`} />
        })}
      </>
    )
  }

  return (
    <div className={`${classes['parties__container']}`}>
      <InlineRenderParties />
    </div>
  )
}
export default Parties
